import React from "react";

import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Avatar } from "antd";

import "./StepCircle.css";

const STATUS_ERROR = 3;
const STATUS_FINISHED = 2;
const STATUS_WAITING = 0;

export default function StepCircle(props) {
  const { number, status, openCreateEnvModalFromTab } = props;

  let marker;
  if (status === STATUS_ERROR) {
    marker = (
      <Avatar
        size={40}
        className="StepCircle__avatar StepCircle__avatar--error"
        icon={<ExclamationCircleOutlined />}
        aria-label="Step error"
      />
    );
  } else if (status === STATUS_FINISHED) {
    marker = (
      <Avatar
        size={40}
        className="StepCircle__avatar StepCircle__avatar--done"
        icon={<CheckOutlined />}
        aria-label="Step complete"
      />
    );
  } else {
    const muted = status === STATUS_WAITING;
    marker = (
      <Avatar
        size={40}
        className={`StepCircle__avatar StepCircle__avatar--ring${muted ? " StepCircle__avatar--muted" : ""}`}
        aria-label={`Step ${number}`}
      >
        {number}
      </Avatar>
    );
  }

  return (
    <div className="StepCircle EnvStepCircle">
      {marker}
      <div className="StepCircle__labels">
        <div className="StepCircle__title">{`Upload ${number === 1 ? "Files" : "Map"}`}</div>
        {openCreateEnvModalFromTab && number === 1 && (
          <div className="StepCircle__optional">Optional</div>
        )}
      </div>
    </div>
  );
}
